module.exports = __webpack_public_path__ + "731d5716b398026193dcf49aea63f4d9.png";